import Assets from '@/views/app/assets/index.vue'
import AppLayout from '@/layouts/App.vue'

import EditPassword from '@/views/app/passwords/Edit.vue'

import Dashboard from '@/views/app/dashboard/index.vue'
import Actions from '@/views/app/actions/index.vue'
import FrequencySets from '@/views/app/frequency-sets/index.vue'
import CreateFrequencySet from '@/views/app/frequency-sets/Create.vue'
import DiagnosticLogs from '@/views/app/diagnostic-logs/index.vue'
import Users from '@/views/app/users/index.vue'
import CreateUser from '@/views/app/users/Create.vue'
import EditUser from '@/views/app/users/Edit.vue'
import PremiumUsers from '@/views/app/users/Premium.vue'
import UploadUsers from '@/views/app/users/Upload.vue'
import UserMap from '@/views/app/user-map/index.vue'
import UserGroups from '@/views/app/user-groups/index.vue'
import CreateUserGroup from '@/views/app/user-groups/Create.vue'
import EditUserGroup from '@/views/app/user-groups/Edit.vue'
import EncryptionKeys from '@/views/app/encryption-keys/index.vue'
import CreateEncryptionKey from '@/views/app/encryption-keys/Create.vue'

import Organizations from '@/views/app/organizations/index.vue'
import CreateOrganization from '@/views/app/organizations/Create.vue'
import EditOrganization from '@/views/app/organizations/Edit.vue'
import Firmware from '@/views/app/firmware/index.vue'
import CreateFirmware from '@/views/app/firmware/Create.vue'
import EditFirmware from '@/views/app/firmware/Edit.vue'
import Compatibility from '@/views/app/compatibility/index.vue'
import MobileFeatures from '@/views/app/mobile-features/index.vue'
import CreateMobileFeature from '@/views/app/mobile-features/Create.vue'
import EditMobileFeature from '@/views/app/mobile-features/Edit.vue'
import DeviceWhitelist from '@/views/app/device-whitelist/index.vue'
import DeviceWhitelistCreate from '@/views/app/device-whitelist/Create.vue'
import RadioSummary from '@/views/app/radios/OrganizationSummary.vue'
import RadioOrganizationDetail from '@/views/app/radios/OrganizationDetail.vue'
import CreateRadio from '@/views/app/radios/Create.vue'
import EditRadio from '@/views/app/radios/Edit.vue'
import UploadRadios from '@/views/app/radios/Upload.vue'
import Roles from '@/views/app/roles/index.vue'
import CreateRole from '@/views/app/roles/Create.vue'
import EditRole from '@/views/app/roles/Edit.vue'
import Permissions from '@/views/app/permissions/index.vue'
import CreatePermission from '@/views/app/permissions/Create.vue'
import EditPermission from '@/views/app/permissions/Edit.vue'
import PermissionGuard from '@/router/guards/permission'
import OrganizationAllows from '@/router/guards/organization-allows'
import FeatureFlagGuard from '@/router/guards/feature-flag'
import AuthGuard from '@/router/guards/auth'
import ToSGuard from '@/router/guards/tos'
import RegistrationTokenGuard from '@/router/guards/registration-token'
import AllUsers from '@/views/app/all-users/index.vue'
import CreateEditPrivilegedUser from '@/views/app/all-users/CreateEdit.vue'

import AppRepository from '@/views/app/app-repository/index.vue'
import AppRepositoryCreate from '@/views/app/app-repository/Create.vue'
import AppRepositoryEdit from '@/views/app/app-repository/Edit.vue'
import AppRepositoryDownloads from '@/views/app/app-repository/Downloads.vue'

import Products from '@/views/app/products/index.vue'
import CreateProduct from '@/views/app/products/Create.vue'
import EditProduct from '@/views/app/products/Edit.vue'

import Relays from '@/views/app/relays/Relays.vue'
import RelayMap from '@/views/app/relays/RelayMap.vue'
import RelayRadios from '@/views/app/relays/RelayRadios.vue'
import CreateRelay from '@/views/app/relays/Create.vue'
import EditRelay from '@/views/app/relays/Edit.vue'
import RelayDetails from '@/views/app/relays/Details.vue'
import UploadRelays from '@/views/app/relays/Upload.vue'
import ProvisionRelay from '@/views/app/relays/Provision.vue'

import Developers from '@/views/app/developers/index.vue'

import ConfigurationSets from '@/views/app/configuration-sets/index.vue'
import CreateEditConfigurationSet from '@/views/app/configuration-sets/CreateEdit.vue'
import CreateEditConfigurationSetDistribution from '@/views/app/configuration-sets/distributions/CreateEdit.vue'
import ConfigurationSetDistributions from '@/views/app/configuration-sets/distributions/index.vue'

import CreateEditAssetRadio from '@/views/app/assets/radios/CreateEdit.vue'
import UploadAssetRadio from '@/views/app/assets/radios/Upload.vue'

import ManageSearchIndexes from '@/views/app/search/index.vue'
import FeatureFlags from '@/views/app/feature-flags/index.vue'

import multiGuard from '@/router/multi-guard'

import featureFlags from '@/constants/feature-flags'

export default [
    {
        path: '',
        component: AppLayout,
        beforeEnter: multiGuard([AuthGuard, ToSGuard]),
        children: [
            {
                path: 'login/:registrationToken',
                name: 'login-token-authed',
                component: Dashboard,
                beforeEnter: RegistrationTokenGuard,
                props: true,
            },
            {
                path: '/:organization_slug/dashboard',
                name: 'admin-dashboard',
                component: Dashboard,
            },
            {
                path: '/:organization_slug/actions',
                name: 'admin-actions',
                component: Actions,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view actions'] },
            },
            {
                path: '/:organization_slug?/change-password',
                name: 'admin-change-password',
                component: EditPassword,
            },
            {
                path: '/:organization_slug/frequency-sets',
                name: 'admin-frequency-sets',
                component: FrequencySets,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view frequency sets'] },
            },
            {
                path: '/:organization_slug/frequency-sets/create',
                name: 'admin-create-frequency-set',
                component: CreateFrequencySet,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['create frequency sets'] },
            },
            {
                path: '/:organization_slug/diagnostic-logs',
                name: 'admin-diagnostic-logs',
                component: DiagnosticLogs,
                beforeEnter: multiGuard([PermissionGuard, FeatureFlagGuard]),
                meta: {
                    permissions: ['view diagnostic logs'],
                    requiresFeatureFlags: [featureFlags.DIAGNOSTIC_LOGS_ENABLED],
                },
            },
            {
                path: '/:organization_slug/premium-users',
                name: 'admin-premium-users',
                component: PremiumUsers,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view license information'] },
            },
            {
                path: '/:organization_slug/encryption-keys',
                name: 'admin-encryption-keys',
                component: EncryptionKeys,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard]),
                meta: { organizationAllows: 'ALLOW_CONFIGURATION_SETS', permissions: ['view encryption keys'] },
            },
            {
                path: '/:organization_slug/encryption-keys/create',
                name: 'admin-create-encryption-key',
                component: CreateEncryptionKey,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard]),
                meta: { organizationAllows: 'ALLOW_CONFIGURATION_SETS', permissions: ['create encryption keys'] },
            },
            {
                path: '/:organization_slug/assets',
                name: 'admin-assets',
                component: Assets,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard, FeatureFlagGuard]),
                meta: {
                    organizationAllows: 'ALLOW_RELAYS',
                    requiresFeatureFlags: [featureFlags.ASSETS_PAGE_FEATURE_ENABLED],
                    permissions: ['view assets'],
                },
            },
            {
                path: '/:organization_slug/users',
                name: 'admin-users',
                component: Users,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view users'] },
            },
            {
                path: '/:organization_slug/users/create',
                name: 'admin-create-user',
                component: CreateUser,
            },
            {
                path: '/:organization_slug/users/upload',
                name: 'admin-upload-users',
                component: UploadUsers,
            },
            {
                path: '/:organization_slug/users/:id/edit',
                name: 'admin-edit-user',
                component: EditUser,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['update users'] },
            },
            {
                path: '/:organization_slug/user-map',
                name: 'admin-user-map',
                component: UserMap,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard]),
                meta: { organizationAllows: 'ALLOW_MAP', permissions: ['view missions'] },
            },
            {
                path: '/:organization_slug/user-groups',
                name: 'admin-user-groups',
                component: UserGroups,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view user groups'] },
            },
            {
                path: '/:organization_slug/user-groups/create',
                name: 'admin-create-user-group',
                component: CreateUserGroup,
            },
            {
                path: '/:organization_slug/user-groups/:id/edit',
                name: 'admin-edit-user-group',
                component: EditUserGroup,
            },
            {
                path: '/:organization_slug/configuration-sets',
                name: 'admin-configuration-sets',
                component: ConfigurationSets,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard, FeatureFlagGuard]),
                meta: {
                    organizationAllows: 'ALLOW_CONFIGURATION_SETS',
                    permissions: ['view configuration sets'],
                    requiresFeatureFlags: [featureFlags.CONFIGURATION_SETS_FEATURE_ENABLED],
                },
            },
            {
                path: '/:organization_slug/configuration-sets/create',
                name: 'admin-create-configuration-set',
                component: CreateEditConfigurationSet,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard, FeatureFlagGuard]),
                meta: {
                    organizationAllows: 'ALLOW_CONFIGURATION_SETS',
                    permissions: [
                        'create configuration sets',
                        'view frequency sets',
                        'view encryption keys',
                        'create frequency sets',
                        'create encryption keys',
                    ],
                    requiresFeatureFlags: [featureFlags.CONFIGURATION_SETS_FEATURE_ENABLED],
                },
            },
            {
                path: '/:organization_slug/configuration-sets/:id/edit',
                name: 'admin-edit-configuration-set',
                component: CreateEditConfigurationSet,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard, FeatureFlagGuard]),
                meta: {
                    organizationAllows: 'ALLOW_CONFIGURATION_SETS',
                    permissions: [
                        'update configuration sets',
                        'view frequency sets',
                        'view encryption keys',
                        'create frequency sets',
                        'create encryption keys',
                    ],
                    requiresFeatureFlags: [featureFlags.CONFIGURATION_SETS_FEATURE_ENABLED],
                },
            },
            {
                path: '/:organization_slug/configuration-sets/:configurationSetId/distributions/create',
                name: 'admin-create-configuration-set-distribution',
                component: CreateEditConfigurationSetDistribution,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard, FeatureFlagGuard]),
                meta: {
                    organizationAllows: 'ALLOW_CONFIGURATION_SETS',
                    permissions: ['create configuration sets'],
                    requiresFeatureFlags: [featureFlags.CONFIGURATION_SETS_FEATURE_ENABLED],
                },
            },
            {
                path:
                    '/:organization_slug/configuration-sets/:configurationSetId' +
                    '/distributions/:configurationSetDistributionId/edit',
                name: 'admin-edit-configuration-set-distribution',
                component: CreateEditConfigurationSetDistribution,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard, FeatureFlagGuard]),
                meta: {
                    organizationAllows: 'ALLOW_CONFIGURATION_SETS',
                    permissions: ['update configuration sets'],
                    requiresFeatureFlags: [featureFlags.CONFIGURATION_SETS_FEATURE_ENABLED],
                },
            },
            {
                path: '/:organization_slug/configuration-sets/:id/distributions',
                name: 'admin-configuration-set-distributions',
                component: ConfigurationSetDistributions,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard, FeatureFlagGuard]),
                meta: {
                    organizationAllows: 'ALLOW_CONFIGURATION_SETS',
                    permissions: ['create configuration sets'],
                    requiresFeatureFlags: [featureFlags.CONFIGURATION_SETS_FEATURE_ENABLED],
                },
            },
            {
                path: '/:organization_slug/configuration-sets/:id/distributions',
                name: 'admin-configuration-set-distributions',
                component: ConfigurationSetDistributions,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard, FeatureFlagGuard]),
                meta: {
                    organizationAllows: 'ALLOW_CONFIGURATION_SETS',
                    permissions: ['create configuration sets'],
                    requiresFeatureFlags: [featureFlags.CONFIGURATION_SETS_FEATURE_ENABLED],
                },
            },
            {
                path: '/:organization_slug/relays',
                name: 'admin-relays',
                component: Relays,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard]),
                meta: { organizationAllows: 'ALLOW_RELAYS', permissions: ['view assets'] },
            },
            {
                path: '/:organization_slug/relays/map',
                name: 'admin-relay-map',
                component: RelayMap,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard]),
                meta: { organizationAllows: 'ALLOW_RELAYS', permissions: ['view assets'] },
            },
            {
                path: '/:organization_slug/relays/radios',
                name: 'admin-radios',
                component: RelayRadios,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard]),
                meta: { organizationAllows: 'ALLOW_RELAYS', permissions: ['view assets'] },
            },
            {
                path: '/:organization_slug/relays/:id/details',
                name: 'admin-relay-details',
                component: RelayDetails,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard]),
                meta: { organizationAllows: 'ALLOW_RELAYS', permissions: ['view assets'] },
            },
            {
                path: '/:organization_slug/relays/:id/details/:radioSerialNumber',
                name: 'admin-relay-details-radio',
                component: RelayDetails,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard]),
                meta: { organizationAllows: 'ALLOW_RELAYS', permissions: ['view assets'] },
            },
            {
                path: '/:organization_slug/relays/create',
                name: 'admin-create-relay',
                component: CreateRelay,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard]),
                meta: { organizationAllows: 'ALLOW_RELAYS', permissions: ['create assets'] },
            },
            {
                path: '/:organization_slug/relays/:relayId/edit',
                name: 'admin-edit-relay',
                component: EditRelay,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard]),
                meta: { organizationAllows: 'ALLOW_RELAYS', permissions: ['update assets'] },
            },
            {
                path: '/:organization_slug/relays/upload',
                name: 'admin-upload-relays',
                component: UploadRelays,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard]),
                meta: { organizationAllows: 'ALLOW_RELAYS', permissions: ['upload assets'] },
            },
            {
                path: '/:organization_slug/relays/provision',
                name: 'admin-provision-relay',
                component: ProvisionRelay,
                beforeEnter: multiGuard([OrganizationAllows, PermissionGuard, FeatureFlagGuard]),
                meta: {
                    organizationAllows: 'ALLOW_RELAYS',
                    permissions: ['create provisioning profiles'],
                    requiresFeatureFlags: [featureFlags.ADVANCED_RELAYS_ENABLED],
                },
            },
            {
                path: '/:organization_slug/assets/radios/create',
                name: 'admin-create-asset-radio',
                component: CreateEditAssetRadio,
                beforeEnter: multiGuard([PermissionGuard]),
                meta: { permissions: ['create assets'] },
            },
            {
                path: '/:organization_slug/asset-radios/upload',
                name: 'admin-upload-asset-radio',
                component: UploadAssetRadio,
                beforeEnter: multiGuard([PermissionGuard]),
                meta: { permissions: ['upload assets'] },
            },
            {
                path: '/:organization_slug/assets/radios/:assetId/edit',
                name: 'admin-edit-asset-radio',
                component: CreateEditAssetRadio,
                beforeEnter: multiGuard([PermissionGuard]),
                meta: { permissions: ['update assets'] },
            },
            {
                path: '/:organization_slug/asset-radios/:assetId/edit',
                name: 'admin-edit-asset-radio',
                component: CreateEditAssetRadio,
                beforeEnter: multiGuard([PermissionGuard]),
                meta: { permissions: ['update assets'] },
            },
            {
                path: ':organization_slug/app-repository',
                name: 'admin-app-repository',
                component: AppRepository,
                beforeEnter: multiGuard([PermissionGuard]),
                meta: { permissions: ['view apps'] },
            },
            {
                path: 'organizations',
                name: 'super-organizations',
                component: Organizations,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view organizations'] },
            },
            {
                path: 'organizations/create',
                name: 'super-create-organization',
                component: CreateOrganization,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['create organizations'] },
            },
            {
                path: 'organizations/:id/edit',
                name: 'super-edit-organization',
                component: EditOrganization,
            },
            {
                path: 'device-whitelist',
                name: 'super-device-whitelist',
                component: DeviceWhitelist,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view device whitelist'] },
            },
            {
                path: 'device-whitelist/create',
                name: 'super-append-to-device-whitelist',
                component: DeviceWhitelistCreate,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['create device whitelist'] },
            },
            {
                path: 'developers',
                name: 'super-developers',
                component: Developers,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view api documentation'] },
            },
            {
                path: 'firmware',
                name: 'super-firmware',
                component: Firmware,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view firmware'] },
            },
            {
                path: 'firmware/create',
                name: 'super-create-firmware',
                component: CreateFirmware,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['create firmware'] },
            },
            {
                path: 'firmware/:id/edit',
                name: 'super-edit-firmware',
                component: EditFirmware,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['update firmware'] },
            },
            {
                path: 'compatibility',
                name: 'super-compatibility',
                component: Compatibility,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view firmware'] },
            },
            {
                path: 'mobile-features',
                name: 'super-mobile-features',
                component: MobileFeatures,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view mobile features'] },
            },
            {
                path: 'mobile-features/create',
                name: 'super-create-mobile-feature',
                component: CreateMobileFeature,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['create mobile features'] },
            },
            {
                path: 'mobile-features/:id/edit',
                name: 'super-edit-mobile-feature',
                component: EditMobileFeature,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['update mobile features'] },
            },
            {
                path: 'radios/summary',
                name: 'super-radios-summary',
                component: RadioSummary,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view radios'] },
            },
            {
                path: 'radios',
                name: 'super-radios',
                component: RadioOrganizationDetail,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view radios'] },
            },
            {
                path: 'radios/create',
                name: 'super-create-radio',
                component: CreateRadio,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['create radios'] },
            },
            {
                path: 'radios/upload',
                name: 'super-upload-radios',
                component: UploadRadios,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['upload radios'] },
            },
            {
                path: 'radios/:id/edit',
                name: 'super-edit-radio',
                component: EditRadio,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['update radios'] },
            },
            {
                path: 'roles',
                name: 'super-roles',
                component: Roles,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view roles'] },
            },
            {
                path: 'roles/create',
                name: 'super-create-role',
                component: CreateRole,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['create roles'] },
            },
            {
                path: 'roles/:id/edit',
                name: 'super-edit-role',
                component: EditRole,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['update roles'] },
            },
            {
                path: 'permissions',
                name: 'super-permissions',
                component: Permissions,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view permissions'] },
            },
            {
                path: 'permissions/create',
                name: 'super-create-permission',
                component: CreatePermission,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['create permissions'] },
            },
            {
                path: 'permissions/:id/edit',
                name: 'super-edit-permission',
                component: EditPermission,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['update permissions'] },
            },
            {
                path: 'users',
                name: 'super-all-users',
                component: AllUsers,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view users', 'search across organizations'] },
            },
            {
                path: 'users/create',
                name: 'super-create-privileged-user',
                component: CreateEditPrivilegedUser,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['create privileged users'] },
            },
            {
                path: 'users/:id/edit',
                name: 'super-edit-privileged-user',
                component: CreateEditPrivilegedUser,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['update privileged users'] },
            },
            {
                path: '/app-repository',
                name: 'app-repository',
                component: AppRepository,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view apps'] },
            },
            {
                path: '/app-repository/create',
                name: 'app-repository-create',
                component: AppRepositoryCreate,
                meta: { permissions: ['create apps'] },
            },
            {
                path: '/app-repository/:id/edit',
                name: 'app-repository-edit',
                component: AppRepositoryEdit,
                meta: { permissions: ['edit apps'] },
            },
            {
                path: '/app-repository/:id/downloads',
                name: 'app-repository-downloads',
                component: AppRepositoryDownloads,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view apps', 'create apps'] },
            },
            {
                path: 'products',
                name: 'super-products',
                component: Products,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view products'] },
            },
            {
                path: 'products/create',
                name: 'super-create-product',
                component: CreateProduct,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['create products'] },
            },
            {
                path: 'products/:id/edit',
                name: 'super-edit-product',
                component: EditProduct,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['update products'] },
            },
            {
                path: 'search',
                name: 'super-search-indexes',
                component: ManageSearchIndexes,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view search indexes'] },
            },
            {
                path: 'feature-flags',
                name: 'super-feature-flags',
                component: FeatureFlags,
                beforeEnter: PermissionGuard,
                meta: { permissions: ['view global feature flags'] },
            },
        ],
    },
]
